import { Label } from "@components";
import styles from "@styles/forms-flow/creative.module.scss";

import classNames from "classnames/bind";
import { If } from "shared/components/control-statements";
import { Icon } from "shared/components/core/Icon";
import { Environment } from "shared/core/Environment";
const css = classNames.bind(styles);

const benefitTypes = {
  CASHBACK: "CASHBACK",
  CASH_DISCOUNT: "CASH_DISCOUNT",
  PERCENTAGE_DISCOUNT: "PERCENTAGE_DISCOUNT",
  FREE_DELIVERY: "FREE_DELIVERY",
  PRODUCT_DISCOUNT: "PRODUCT_DISCOUNT",
  PRODUCT_CASH_DISCOUNT: "PRODUCT_CASH_DISCOUNT",
};

export const BenefitType = ({ selectedBenefit, setSelectedBenefit }) => {
  const CASH_DISCOUNT = selectedBenefit === benefitTypes.CASH_DISCOUNT;
  const PERCENTAGE_DISCOUNT =
    selectedBenefit === benefitTypes.PERCENTAGE_DISCOUNT;
  const CASHBACK = selectedBenefit === benefitTypes.CASHBACK;
  const FREE_DELIVERY = selectedBenefit === benefitTypes.FREE_DELIVERY;
  const PRODUCT_DISCOUNT = selectedBenefit === benefitTypes.PRODUCT_DISCOUNT;
  const PRODUCT_CASH_DISCOUNT =
    selectedBenefit === benefitTypes.PRODUCT_CASH_DISCOUNT;

  const programByPoint =
    localStorage.getItem("cashbackProgramType") === "POINT";

  return (
    <>
      <Label>Determine o benefício</Label>

      <div className={styles.benefits}>
        <div
          className={css({
            option: true,
            active: CASH_DISCOUNT,
          })}
          onClick={() => setSelectedBenefit(benefitTypes.CASH_DISCOUNT)}
        >
          <Icon name="sack-dollar" light />
          <p>Desconto em R$</p>
        </div>

        <div
          className={css({
            option: true,
            active: PERCENTAGE_DISCOUNT,
          })}
          onClick={() => setSelectedBenefit(benefitTypes.PERCENTAGE_DISCOUNT)}
        >
          <Icon name="percent" light />
          <p>Desconto em %</p>
        </div>

        <div
          className={css({
            option: true,
            active: FREE_DELIVERY,
          })}
          onClick={() => setSelectedBenefit(benefitTypes.FREE_DELIVERY)}
        >
          <Icon name="motorcycle" light />
          <p>Entrega grátis</p>
        </div>

        <If cond={!programByPoint}>
          <div
            className={css({
              option: true,
              active: CASHBACK,
            })}
            onClick={() => setSelectedBenefit(benefitTypes.CASHBACK)}
          >
            <Icon name="hand-holding-dollar" light />
            <p>Cashback</p>
          </div>
        </If>

        <If cond={programByPoint}>
          <div
            className={css({
              option: true,
              active: CASHBACK,
            })}
            onClick={() => setSelectedBenefit(benefitTypes.CASHBACK)}
          >
            <Icon name="circle-1" light />
            <p>Pontos</p>
          </div>
        </If>

        <div
          className={css({
            option: true,
            active: PRODUCT_DISCOUNT,
          })}
          onClick={() => setSelectedBenefit(benefitTypes.PRODUCT_DISCOUNT)}
        >
          <Icon name="pot-food" light />

          <p>Desconto em produto</p>
        </div>

        {(Environment.id === 66 || Environment.id === 8) && (
          <div
            className={css({
              option: true,
              active: PRODUCT_CASH_DISCOUNT,
            })}
            onClick={() =>
              setSelectedBenefit(benefitTypes.PRODUCT_CASH_DISCOUNT)
            }
          >
            <Icon name="pot-food" light />

            <p>Produto (desconto em R$)</p>
          </div>
        )}
      </div>
    </>
  );
};
